import { setLayout } from '../../../State/layout'

export default () => (dispatch) => {

  dispatch(setLayout('list'))

}
